import { type ReactElement, type ReactNode } from 'react';

import { cn } from '@/lib/utils';

export function DataTable({
  children,
  className,
  'aria-label': ariaLabel,
}: {
  readonly children: ReactNode;
  readonly className?: string;
  /** Passed to the wrapping region (accessibility for the table + chrome). */
  readonly 'aria-label'?: string;
}): ReactElement {
  return (
    <div
      role="region"
      className={cn(
        'overflow-hidden rounded-lg border border-border bg-white text-foreground dark:bg-card',
        className,
      )}
      aria-label={ariaLabel}
    >
      {children}
    </div>
  );
}
